// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthLayout_wrapper__veU1P","main":"AuthLayout_main__K1oB0"};